export enum AbTestKeys {
	PdpCopyShopTheLook = 'pdp_copy_shop_the_look',
	PlpA2bPhase4 = 'plp_a2b_fase_4',
	PromoBanner = 'promo_countdown',
	Test = 'test',
	PlpFirstFourSegmentation = 'plp_first_four_segmentation',
	PdpSizesSheet = 'pdp_sizes_sheet',
	NewSearchUi = 'search_new_ui_v3',
	PaymentsKlarnaInstallments = 'payments_klarna_installments',
	SearchInternalService = 'search_internal_service', // server test key, dont't remove
	KlarnaBenefits = 'payments_klarna_benefits',
	BackInStockNewsletter = 'back_in_stock_newsletter',
}
